import React, { Component, Fragment } from "react";
import Input from "../../Common/Input";
import Error from "../../Common/Error";
import { commonService } from "../../../storeManager/common/services";


class EvaluationForm extends Component {

  renderForm = (evaluationFormArray) => {
    const formType = "evaluationForm";
    const {
      inputChangedHandler,
      radioChangeHandler,
      addRemoveObj,
      selectHandler,
      evalFormAssocFieldChageHandler,
      evalFormBankChageHandler,
      addRemoveBankObj,
      termsConditionChangeHandler,
      formConfig,
      formSubmit,
      formErrorMessage,
      addRemovePincodesObj,
      evalFormPincodesChageHandler,
      evalFormCalculatePincodesHandler,
      storeSelectHandler,
      isSecondApplication,
    } = this.props;
    let formArr = [];
    for (let i = 0; i < evaluationFormArray.length; i++) {
      const formElement = evaluationFormArray[i];
      if (formElement.id === "firmType" || formElement.id === "shopOwnerShip") {
      }/*else if(formElement.config.isTermsAndCondition) {
        if( formConfig && formConfig.buttonArray && !!formConfig.buttonArray.length){
        formArr.push(<div key={`${formElement.id}${i}`} className="notes align-left mtb20">
        <div className={`checkbox-element ${!formElement.config.valid ? 'error':''}`}>
          <input type="checkbox" checked={formElement.config.value} onChange={(e)=>{termsConditionChangeHandler(e.target.checked, formType)}}/>
          <span className="checkmark" />
        </div>
        <span className="pl30 pr5">By submitting, I agree to all</span>
        <span className="title">Terms of Service</span>
        <span className='required'>*</span>
        {!formElement.config.valid ? <span className="invalid-text">{formElement.config.errorMessage}</span>:null}
      </div>)
        }
      }*/
      else if (formElement.config.isHeader) {
        formArr.push(
          <div className={`pb20 ${formElement.config.classes ? formElement.config.classes : ''}`} key={`${formElement.id}${i}`}>
            <div className="title-2 pb10">{formElement.config.isHeader}</div>
            <hr className="no-space" />
          </div>
        );
      } else if (formElement.config.isSubHeader) {
        formArr.push(
          <div className="mb5" key={`${formElement.id}${i}`}>
            {formElement.config.isSubHeader}
            {formElement.config.isRequired ? <span className='required'>*</span>:null}
          </div>
        );
      }
      else if (formElement.id === "currentBusinessAssociation") {
        const arrList = formElement.config;
        arrList.map((currBusObj, upperIndex) => {
          const {id, ...currBusObjWithoutId} = currBusObj;
          const keys = Object.keys(currBusObjWithoutId);
          keys &&
            keys.map((Obj, index, ObjArray) => {
              const configObj = currBusObj[Obj];
              const commonInput = (
                <Input
                  labelConfig={configObj.labelConfig}
                  elementType={configObj.elementType}
                  elementConfig={configObj.elementConfig}
                  value={configObj.value}
                  valid={configObj.valid}
                  errorMessage={configObj.errorMessage}
                  touched={configObj.touched}
                  wrapperClasses={configObj.wrapperClasses}
                  inputGroupClasses={configObj.inputGroupClasses}
                  selectConfig={configObj.selectConfig}
                  selectHandler={event => {
                    evalFormAssocFieldChageHandler(
                      event,
                      keys[index],
                      "currentBusinessAssociation",
                      upperIndex,
                      true
                    );
                  }}
                  changed={event => {
                    evalFormAssocFieldChageHandler(
                      event,
                      keys[index],
                      "currentBusinessAssociation",
                      upperIndex,
                      false
                    );
                  }}
                />
              );
              formArr.push(
                <Fragment
                  key={`${formElement.id}${keys[index]}${i}${upperIndex}${index}`}
                >
                  {!configObj.isButton && (
                    <React.Fragment>
                      {configObj.inputGroupClasses ? (
                        <div
                          className={`${configObj.containerClass} mb0 clearfix`}
                        >
                          {commonInput}
                        </div>
                      ) : (
                        <React.Fragment>{commonInput}</React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  {ObjArray.length - 1 === index && (
                    <button
                    type="button"
                      className={`button fill ml10 add-btn-right mb10 ${upperIndex !== 0 ? 'remove':''}`}
                      onClick={e => {
                        e.preventDefault();
                        addRemoveObj(
                          e,
                          "currentBusinessAssociation",
                          upperIndex === 0 ? "More" : "",
                          upperIndex
                        );
                      }}
                    >
                      {upperIndex === 0 ? (
                        <>
                          <i className="action-icon">
                            <svg width="12" height="13" viewBox="0 0 23 24">
                              <path
                                fill="#FFF"
                                fillRule="evenodd"
                                d="M14.414.011H8.681V9.31H.015v5.377h8.666v9.3h5.733v-9.3h8.601V9.31h-8.601V.011z"
                              />
                            </svg>
                          </i>
                          <span className="text">More</span>
                        </>
                      ) : (
                        <i className="action-icon">
                          <svg width="14" height="18" viewBox="0 0 22 27">
                            <path
                              fill="#FFF"
                              fillRule="evenodd"
                              d="M20.036 9.343v14.572c0 1.701-1.394 3.085-3.108 3.085H5.072c-1.714 0-3.108-1.384-3.108-3.085V9.343A3.086 3.086 0 010 6.478V6.32c0-1.701 1.394-3.085 3.108-3.085h4.235A3.678 3.678 0 0111 0a3.677 3.677 0 013.657 3.235h4.235C20.606 3.235 22 4.619 22 6.32v.158c0 1.3-.815 2.412-1.964 2.865zM3.438 23.915a1.63 1.63 0 001.634 1.622h11.856a1.63 1.63 0 001.634-1.622V9.563H3.438v14.352zM11 1.463a2.209 2.209 0 00-2.168 1.772h4.336A2.208 2.208 0 0011 1.463zm9.526 4.857a1.63 1.63 0 00-1.634-1.622H3.108A1.63 1.63 0 001.474 6.32v.158A1.63 1.63 0 003.108 8.1h15.784a1.63 1.63 0 001.634-1.622V6.32zm-5.575 17.346a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.738-.731v-8.236c0-.404.331-.731.738-.731.406 0 .736.327.736.731v8.236c0 .404-.33.731-.736.731z"
                            />
                          </svg>
                        </i>
                      )}
                    </button>
                  )}
                </Fragment>
              );
            });
        });
      }
      else if (formElement.id === "bankDetails") {
        const arrList = formElement.config;
        arrList.map((currBankObj, upperIndex)=>{
          const {id, ...currBankObjWithoutId} = currBankObj;
          let otherObj = {};
          if(currBankObjWithoutId.bank && currBankObjWithoutId.bank.isOther){
            otherObj = {...currBankObjWithoutId};
          }else{
            let {otherBank, ...currBankObjWithoutOther} = currBankObjWithoutId;
            otherObj ={...currBankObjWithoutOther};
          }
          const keys = Object.keys(otherObj);
          let commonInput = [];
          keys &&
            keys.map((Obj, index, ObjArray) => {
              const config = currBankObj[Obj];
              // let commonInput = [];
           commonInput.push(<Input
            key={`${formElement.id}${index}`}
            labelConfig={config.labelConfig}
            elementType={config.elementType}
            elementConfig={config.elementConfig}
            value={config.value}
            valid={config.valid}
            errorMessage={config.errorMessage}
            touched={config.touched}
            wrapperClasses={config.wrapperClasses}
            inputGroupClasses={config.inputGroupClasses}
            // selectHandler={(event, index) => {
            //   // debugger;
            //   evalFormBankChageHandler(
            //     event,
            //     keys[index],
            //     // "currentBusinessAssociation",
            //     upperIndex,
            //     // true
            //     );
            // }}
            changed={event =>
              evalFormBankChageHandler(
                event,
                keys[index],
                // "currentBusinessAssociation",
                upperIndex,
                // false
                )
            }
          />);
        });

          formArr.push(
            <div className="d-flex" key={`${formElement.id}${upperIndex}`}>
              {commonInput}

                    {(<button type="button" className={`button fill ml10 add-btn mt20 mb10 ${upperIndex !== 0 ? 'remove':''}`} disabled = {isSecondApplication}
                      onClick={e => {
                        e.preventDefault();
                        addRemoveBankObj(
                          e,
                          "bankDetails",
                          upperIndex === 0 ? "More" : "",
                          upperIndex
                        );
                      }}
                    >
                      {upperIndex === 0 ? (
                        <>
                          <i>
                            <svg width="12" height="13" viewBox="0 0 23 24">
                              <path
                                fill="#FFF"
                                fillRule="evenodd"
                                d="M14.414.011H8.681V9.31H.015v5.377h8.666v9.3h5.733v-9.3h8.601V9.31h-8.601V.011z"
                              />
                            </svg>
                          </i>
                          <span className="text">More</span>
                        </>
                      ) : (
                        <i className="delete-icon">
                          <svg width="14" height="18" viewBox="0 0 22 27">
                            <path
                              fill="#FFF"
                              fillRule="evenodd"
                              d="M20.036 9.343v14.572c0 1.701-1.394 3.085-3.108 3.085H5.072c-1.714 0-3.108-1.384-3.108-3.085V9.343A3.086 3.086 0 010 6.478V6.32c0-1.701 1.394-3.085 3.108-3.085h4.235A3.678 3.678 0 0111 0a3.677 3.677 0 013.657 3.235h4.235C20.606 3.235 22 4.619 22 6.32v.158c0 1.3-.815 2.412-1.964 2.865zM3.438 23.915a1.63 1.63 0 001.634 1.622h11.856a1.63 1.63 0 001.634-1.622V9.563H3.438v14.352zM11 1.463a2.209 2.209 0 00-2.168 1.772h4.336A2.208 2.208 0 0011 1.463zm9.526 4.857a1.63 1.63 0 00-1.634-1.622H3.108A1.63 1.63 0 001.474 6.32v.158A1.63 1.63 0 003.108 8.1h15.784a1.63 1.63 0 001.634-1.622V6.32zm-5.575 17.346a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.738-.731v-8.236c0-.404.331-.731.738-.731.406 0 .736.327.736.731v8.236c0 .404-.33.731-.736.731z"
                            />
                          </svg>
                        </i>
                      )}
                    </button>)}

            </div>
              );
        // });
      });
      }else if (formElement.id === "pinCodes") {
        const arrList = formElement.config;
        arrList.map((currentPinCodesObject, upperIndex)=>{
          const {id, ...currPinCodeObjWithoutId} = currentPinCodesObject;
          let otherObj = {};
          if(currPinCodeObjWithoutId.pinCodes){
            otherObj = {...currPinCodeObjWithoutId};
          }
          // else{
          //   let {otherBank, ...currBankObjWithoutOther} = currPinCodeObjWithoutId;
          //   otherObj ={...currBankObjWithoutOther};
          // }  
          const keys = Object.keys(otherObj);
          let commonInput = [];
          keys &&
            keys.map((Obj, index, ObjArray) => {
              const config = currentPinCodesObject[Obj];
              // let commonInput = [];
           commonInput.push(<Input
            key={`${formElement.id}${index}`}
            labelConfig={config.labelConfig}
            elementType={config.elementType}
            elementConfig={config.elementConfig}
            value={config.value}
            valid={config.valid}
            errorMessage={config.errorMessage}
            touched={config.touched}
            wrapperClasses={config.wrapperClasses}
            inputGroupClasses={config.inputGroupClasses}
            changed={event =>
              evalFormPincodesChageHandler(
                event,
                keys[index],
                // "currentBusinessAssociation",
                upperIndex,
                // false
                )
            }
          />);
        });

          formArr.push(
            <div className="d-flex" key={`${formElement.id}${upperIndex}`}>
              {commonInput}

                    {(<button type="button" className={`button fill ml10 add-btn mt20 mb10 ${upperIndex !== 0 ? 'remove':''}`}
                      onClick={e => {
                        e.preventDefault();
                        addRemovePincodesObj(
                          e,
                          "pinCodes",
                          upperIndex === 0 ? "More" : "",
                          upperIndex
                        );
                      }}
                    >
                      {upperIndex === 0 ? (
                        <>
                          <i>
                            <svg width="12" height="13" viewBox="0 0 23 24">
                              <path
                                fill="#FFF"
                                fillRule="evenodd"
                                d="M14.414.011H8.681V9.31H.015v5.377h8.666v9.3h5.733v-9.3h8.601V9.31h-8.601V.011z"
                              />
                            </svg>
                          </i>
                          <span className="text">More</span>
                        </>
                      ) : (
                        <i className="delete-icon">
                          <svg width="14" height="18" viewBox="0 0 22 27">
                            <path
                              fill="#FFF"
                              fillRule="evenodd"
                              d="M20.036 9.343v14.572c0 1.701-1.394 3.085-3.108 3.085H5.072c-1.714 0-3.108-1.384-3.108-3.085V9.343A3.086 3.086 0 010 6.478V6.32c0-1.701 1.394-3.085 3.108-3.085h4.235A3.678 3.678 0 0111 0a3.677 3.677 0 013.657 3.235h4.235C20.606 3.235 22 4.619 22 6.32v.158c0 1.3-.815 2.412-1.964 2.865zM3.438 23.915a1.63 1.63 0 001.634 1.622h11.856a1.63 1.63 0 001.634-1.622V9.563H3.438v14.352zM11 1.463a2.209 2.209 0 00-2.168 1.772h4.336A2.208 2.208 0 0011 1.463zm9.526 4.857a1.63 1.63 0 00-1.634-1.622H3.108A1.63 1.63 0 001.474 6.32v.158A1.63 1.63 0 003.108 8.1h15.784a1.63 1.63 0 001.634-1.622V6.32zm-5.575 17.346a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.737-.731v-8.236c0-.404.33-.731.737-.731s.737.327.737.731v8.236c0 .404-.33.731-.737.731zm-3.951 0a.734.734 0 01-.738-.731v-8.236c0-.404.331-.731.738-.731.406 0 .736.327.736.731v8.236c0 .404-.33.731-.736.731z"
                            />
                          </svg>
                        </i>
                      )}
                    </button>)}

            </div>
              );
        // });
      });
      } else if (formElement.id === "activeSubscriber") {
        let commonInput = [];
        commonInput.push(<Input
            key={`${formElement.id}${i}`}
            labelConfig={formElement.config.labelConfig}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            valid={formElement.config.valid}
            errorMessage={formElement.config.errorMessage}
            touched={formElement.config.touched}
            wrapperClasses={formElement.config.wrapperClasses}
            inputGroupClasses={formElement.config.inputGroupClasses}
            selectHandler={(event, index) => {
              selectHandler(event, formElement.id, null, formType);
            }}
            changed={(event) => {
              inputChangedHandler(event, formElement.id, formType)
            }   }
          />)
        // };

          formArr.push(
            <div className="d-flex" key={`${formElement.id}${i}`}>
              {commonInput}

                    {(<button type="button" className="button action calculate ml10 mt20 mb10"
                      onClick={e => {
                        e.preventDefault();
                        evalFormCalculatePincodesHandler(e, "pinCodes");
                      }}
                    >
                    Calculate
                    </button>)}

            </div>
              );
        // });
      // };
      } else if (Array.isArray(formElement.config.radioConfig) && (formElement.id === 'isFamilyInDTH')) {
        let disabledClass = '';
        // if(formElement.id === 'isFamilyInDTH') {
          
          const isGst = formElement.config.radioConfig[0].elementConfig.checked;
          if(!isGst) {
              disabledClass = 'disabled';
          }
        // } 
        formArr.push(
          <div className={`form-control-group ${disabledClass}`} key={`${formElement.id}${i}`}>
            <Input
              labelConfig={formElement.config.labelConfig}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              valid={formElement.config.valid}
              errorMessage={formElement.config.errorMessage}
              touched={formElement.config.touched}
              wrapperClasses={formElement.config.wrapperClasses}
              inputGroupClasses={formElement.config.inputGroupClasses}
              radioConfig={formElement.config.radioConfig}
              radioChangeHandler={(event, index) =>
                radioChangeHandler(event, formElement.id, index, formType)
              }
              changed={(event, index) =>
                inputChangedHandler(event, formElement.id, formType)
              }
              isFamilyInDTH={!!disabledClass}
            />
          </div>
        );        
      } else if(Array.isArray(formElement.config.radioConfig)) {
        formArr.push(
          <Input
            key={`${formElement.id}${i}`}
            labelConfig={formElement.config.labelConfig}
            wrapperClasses={formElement.config.wrapperClasses}
            valid={formElement.config.valid}
            inputGroupClasses={formElement.config.inputGroupClasses}
            radioConfig={formElement.config.radioConfig}
            isDisabled={formElement.id === 'wareHouseAvailable' ? isSecondApplication : false}
            radioChangeHandler={(event, index) =>
              radioChangeHandler(event, formElement.id, index, formType)
            }
          />
        );
      } else {
        formArr.push(
          <Input
            key={`${formElement.id}${i}`}
            labelConfig={formElement.config.labelConfig}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            valid={formElement.config.valid}
            errorMessage={formElement.config.errorMessage}
            touched={formElement.config.touched}
            wrapperClasses={formElement.config.wrapperClasses}
            inputGroupClasses={formElement.config.inputGroupClasses}
            selectHandler={(event, index) => {
              selectHandler(event, formElement.id, null, formType);
            }}
            changed={(event) => {
              inputChangedHandler(event, formElement.id, formType)
            }   }
          />
        );
      }
    }
    {
      formErrorMessage && formArr.push(<Error key={'evalFormErr'} error={formErrorMessage} />)
    }

    if (formConfig && formConfig.buttonArray) {
      formConfig.buttonArray.forEach((item,index) => {
        formArr.push(
          <div key={index}>
            {
              (item.priority === 'PRIMARY') ?
                <div className="f-left"><button
                  className="button fill big w-210 mt10 mb30 mr20"
                  onClick={e => formSubmit(e, "evaluationForm",item)}
                >
                  {item.label}
                </button></div>
                :
                (item.priority === 'SECONDARY') ?
                <button
                  className="button action big w-210 mt10 mb30"
                  type="button"
                  onClick={e => formSubmit(e, "evaluationForm",item)}
                >
                  {item.label}
                </button>
                :null
            }
          </div>)
      })
    }
    return formArr;
  };

  render() {
    const { evaluationForm, radioChangeHandler, formConfig, isSecondApplication } = this.props;
    let { storeEditable, storeEnable } = evaluationForm;
    const formType = "evaluationForm";
    const evaluationFormArray = [];
    const evaluationFormKeys = Object.keys(evaluationForm);
    if(storeEnable) {
      evaluationFormKeys.forEach(key => {
        if(key !== "storeEnable" && key !== "storeEditable") {
          evaluationFormArray.push({
            id: key,
            config: evaluationForm[key]
          });
        }
      });
    }else {
      evaluationFormKeys.forEach(key => {
        if(!evaluationForm[key].formTypeStore && key !== "storeEnable" && key !== "storeEditable" && key !== "pinCodes") {
          evaluationFormArray.push({
            id: key,
            config: evaluationForm[key]
          });
        }
      });
    }

    let renderedForm = this.renderForm(evaluationFormArray, storeEnable);
    const firmType = evaluationForm.firmType;
    const shopOwnerShip = evaluationForm.shopOwnerShip;

    return (
      <div className={"evaluation-form"}>
        <div className="pb25">
          <div className="title-1 pr10">Evaluation Form</div>

          <div className="description">To be filled byASI / ASM</div>
        </div>

        <form>
          <fieldset disabled={!formConfig.editable} className={`${!formConfig.editable ? "application-form-disabled":''}`}>
          <div className="pb20">
            <div className="title-2 pb10">Applicant Details</div>
            <hr className="no-space" />
          </div>
          <div className="radio-group mb10">
            <div className="pb10">{firmType.labelConfig.label}<span className='required'>*</span></div>
            <div className="radio-field image-type">
              <input
                type="radio"
                className="radio-element"
                name="firmType"
                checked={firmType.radioConfig[0].elementConfig.checked}
                value={firmType.radioConfig[0].elementConfig.value}
                disabled={isSecondApplication}
                onChange={event =>
                  radioChangeHandler(event, "firmType", 0, formType)
                }
              />

              <i className="radio-icon">
                <svg width="47.5" height="50" viewBox="0 0 95 100">
                  <path
                    fill="#354060"
                    fillRule="evenodd"
                    d="M92.701 100c-.932 0-1.553-.629-1.553-1.572 0-16.983-13.664-30.664-30.278-30.664h-7.628l-4.169 5.399 4.344 20.233L47.05 100l-6.366-6.447 4.678-19.956-4.503-5.833h-7.473c-16.769 0-30.278 13.838-30.278 30.664 0 .943-.621 1.572-1.553 1.572-.932 0-1.553-.629-1.553-1.572 0-18.686 14.864-33.763 33.305-33.807C24.28 60.5 17.423 52.433 14.821 42.579c-3.459-.134-6.279-3.046-6.279-6.579 0-3.228 2.355-5.939 5.399-6.488C16.014 12.835 30.008-.01 47.05-.01c17.048 0 31.046 12.854 33.112 29.538 2.969.612 5.241 3.299 5.241 6.472 0 3.459-2.706 6.311-6.065 6.557a33.524 33.524 0 01-18.521 22.065c18.43.056 33.281 15.285 33.281 33.806.156.943-.621 1.572-1.397 1.572zM13.666 33.799c0-.32.015-.636.024-.953-1.193.544-2.042 1.761-2.042 3.154 0 1.554 1.058 2.879 2.47 3.304a34.655 34.655 0 01-.452-5.505zM82.298 36c0-1.329-.778-2.49-1.885-3.067.007.289.021.575.021.866a33.853 33.853 0 01-.402 5.439c1.308-.487 2.266-1.76 2.266-3.238zM47.05 95.44l3.106-3.145-2.95-13.366L44.1 92.452l2.95 2.988zm0-24.688l2.276-2.988h-4.551l2.275 2.988zm30.279-36.953c.136-14.704-10.282-27.124-24.103-30.024a20.538 20.538 0 018.886 8.795c.466.786.155 1.73-.621 2.201-.776.315-1.708 0-2.019-.628-2.53-4.861-6.924-7.982-11.776-9.004a20.573 20.573 0 019.292 9.004c.466.786.155 1.729-.621 2.201-.777.314-1.708 0-2.019-.629-3.537-6.794-10.714-10.171-17.694-9.182-.157.077-.317.137-.473.219a1.45 1.45 0 01-1.27.121 17.282 17.282 0 00-3.854 1.451 1.44 1.44 0 01-1.083.168 30.797 30.797 0 00-13.202 25.307c0 16.982 13.664 30.663 30.278 30.663 16.615 0 30.279-13.838 30.279-30.663zm-31.055 11.95c.155-.471.466-.786 1.087-.943l7.764-2.359-8.23-8.334a1.533 1.533 0 010-2.201c.621-.629 1.553-.629 2.174 0l10.093 10.221c.31.314.466.943.466 1.572-.156.472-.466.944-1.087 1.101l-8.385 2.201 3.416 4.718c.466.629.31 1.73-.311 2.201a1.172 1.172 0 01-.776.315c-.466 0-.932-.157-1.242-.629l-4.814-6.447c-.31-.472-.31-.944-.155-1.416zm9.006-8.648a1.534 1.534 0 010-2.202 9.474 9.474 0 0113.509 0 1.534 1.534 0 010 2.202c-.466.314-.777.471-1.242.471-.466 0-.777-.157-1.087-.471a6.316 6.316 0 00-9.006 0c-.621.629-1.553.629-2.174 0zm-17.391.471c-.466 0-.776-.157-1.087-.471a6.316 6.316 0 00-9.006 0c-.621.629-1.552.629-2.173 0a1.533 1.533 0 010-2.202 9.473 9.473 0 0113.508 0 1.534 1.534 0 010 2.202c-.465.314-.776.471-1.242.471z"
                  />
                </svg>
              </i>
              <label htmlFor="yes" className="radio-text">
                {firmType.radioConfig[0].labelConfig.label}
              </label>
              <span className="select-radio" />
            </div>

            <div className="radio-field image-type">
              <input
                type="radio"
                className="radio-element"
                checked={firmType.radioConfig[1].elementConfig.checked}
                name="firmType"
                value={firmType.radioConfig[1].elementConfig.value}
                disabled={isSecondApplication}
                onChange={event =>
                  radioChangeHandler(event, "firmType", 1, formType)
                }
              />
              <i className="radio-icon">
                <svg width="84" height="45" viewBox="0 0 168 90">
                  <path
                    fill="#354060"
                    fillRule="evenodd"
                    d="M154.642 38.323a30.202 30.202 0 01-16.721 19.837c16.644.051 30.055 13.756 30.055 30.425.141.849-.561 1.415-1.262 1.415-.841 0-1.402-.566-1.402-1.415 0-15.285-12.339-27.597-27.343-27.597h-6.889l-3.764 4.859 3.922 18.209L125.489 90l-5.749-5.802 4.225-17.961-4.067-5.249h-6.748c-15.144 0-27.343 12.454-27.343 27.597 0 .849-.561 1.415-1.403 1.415-.133 0-.246-.037-.364-.065-.108.028-.214.065-.326.065-.841 0-1.402-.566-1.402-1.415 0-15.285-12.339-27.597-27.343-27.597H48.08l-3.764 4.859 3.922 18.209L42.489 90l-5.749-5.802 4.225-17.961-4.067-5.249H30.15c-15.144 0-27.343 12.454-27.343 27.597 0 .849-.561 1.415-1.403 1.415-.841 0-1.402-.566-1.402-1.415 0-16.817 13.423-30.387 30.076-30.426-8.149-3.708-14.339-10.963-16.691-19.826-3.126-.118-5.673-2.752-5.673-5.933 0-2.906 2.126-5.355 4.877-5.848C14.467 11.547 27.102-.009 42.489-.009c15.395 0 28.035 11.568 29.901 26.583 2.682.55 4.734 2.97 4.734 5.826 0 3.116-2.444 5.707-5.482 5.923A30.202 30.202 0 0154.921 58.16c13.978.042 25.673 9.718 29.061 22.689 3.374-13.055 15.093-22.657 29.098-22.689-8.149-3.707-14.341-10.963-16.693-19.827-3.126-.118-5.673-2.752-5.673-5.933 0-2.906 2.126-5.355 4.877-5.848C97.467 11.547 110.102-.009 125.489-.009c15.395 0 28.035 11.568 29.901 26.583 2.682.55 4.734 2.97 4.734 5.826 0 3.116-2.444 5.707-5.482 5.923zm-142.3-7.904c0-.288.013-.572.021-.858-1.077.49-1.844 1.585-1.844 2.839 0 1.398.956 2.591 2.231 2.973a30.97 30.97 0 01-.408-4.954zM74.319 32.4c0-1.196-.702-2.241-1.702-2.76.007.259.02.517.02.779a30.401 30.401 0 01-.364 4.896c1.182-.439 2.046-1.585 2.046-2.915zM39.825 83.207l2.664 2.689 2.805-2.831-2.665-12.029-2.804 12.171zm2.664-19.53l2.055-2.689h-4.11l2.055 2.689zm27.343-33.258c.123-13.233-9.285-24.412-21.766-27.021a18.516 18.516 0 018.025 7.915c.42.708.14 1.557-.561 1.981-.701.283-1.543 0-1.823-.566-2.285-4.374-6.253-7.183-10.635-8.102a18.545 18.545 0 018.391 8.102c.421.708.141 1.557-.56 1.982-.702.283-1.543 0-1.823-.567C45.885 8.029 39.404 4.99 33.1 5.88c-.141.069-.286.123-.426.197a1.324 1.324 0 01-1.158.112 15.563 15.563 0 00-3.47 1.303 1.317 1.317 0 01-.99.16 27.688 27.688 0 00-11.91 22.767c0 15.284 12.34 27.597 27.343 27.597 15.004 0 27.343-12.454 27.343-27.597zm25.51 0c0-.288.013-.572.021-.858-1.077.49-1.844 1.585-1.844 2.839 0 1.398.956 2.591 2.231 2.973a30.97 30.97 0 01-.408-4.954zm30.147 55.477l2.805-2.831-2.665-12.029-2.804 12.171 2.664 2.689zm0-22.219l2.055-2.689h-4.11l2.055 2.689zm5.577-60.279a18.516 18.516 0 018.025 7.915c.42.708.14 1.557-.561 1.981-.701.283-1.543 0-1.823-.566-2.285-4.374-6.253-7.183-10.635-8.102a18.545 18.545 0 018.391 8.102c.421.708.141 1.557-.56 1.982-.702.283-1.543 0-1.823-.567-3.195-6.114-9.676-9.153-15.98-8.263-.141.069-.286.123-.426.197a1.324 1.324 0 01-1.158.112 15.563 15.563 0 00-3.47 1.303 1.317 1.317 0 01-.99.16 27.688 27.688 0 00-11.91 22.767c0 15.284 12.34 27.597 27.343 27.597 15.004 0 27.343-12.454 27.343-27.597.123-13.233-9.285-24.412-21.766-27.021zm24.551 26.242c.007.259.02.517.02.779a30.401 30.401 0 01-.364 4.896c1.182-.439 2.046-1.585 2.046-2.915 0-1.196-.702-2.241-1.702-2.76zm-20.733 3.751c-.561.566-1.402.566-1.963 0a1.377 1.377 0 010-1.982 8.577 8.577 0 0112.199 0 1.377 1.377 0 010 1.982c-.42.283-.701.424-1.122.424-.42 0-.701-.141-.981-.424a5.717 5.717 0 00-8.133 0zm1.963 5.944c-.14.424-.421.849-.981.99l-7.572 1.982 3.085 4.245c.42.566.28 1.557-.281 1.982-.14.141-.421.283-.701.283-.421 0-.841-.142-1.122-.566l-4.347-5.803c-.28-.424-.28-.849-.14-1.274.14-.424.421-.707.982-.849l7.011-2.123-7.432-7.5a1.377 1.377 0 010-1.982c.561-.566 1.402-.566 1.963 0l9.114 9.199c.281.283.421.85.421 1.416zm-19.631-5.52c-.421 0-.701-.141-.981-.424a5.717 5.717 0 00-8.133 0c-.561.566-1.402.566-1.963 0a1.377 1.377 0 010-1.982 8.577 8.577 0 0112.199 0 1.377 1.377 0 010 1.982c-.421.283-.701.424-1.122.424zm-75.428 7.359c.14-.424.421-.707.982-.849l7.011-2.123-7.432-7.5a1.377 1.377 0 010-1.982c.561-.566 1.402-.566 1.963 0l9.114 9.199c.281.283.421.85.421 1.416-.14.424-.421.849-.981.99l-7.572 1.982 3.085 4.245c.42.566.28 1.557-.281 1.982-.14.141-.421.283-.701.283-.421 0-.841-.142-1.122-.566l-4.347-5.803c-.28-.424-.28-.849-.14-1.274zm10.096-7.783c-.561.566-1.402.566-1.963 0a1.377 1.377 0 010-1.982 8.577 8.577 0 0112.199 0 1.377 1.377 0 010 1.982c-.42.283-.701.424-1.122.424-.42 0-.701-.141-.981-.424a5.717 5.717 0 00-8.133 0zm-17.668.424c-.421 0-.701-.141-.981-.424a5.717 5.717 0 00-8.133 0c-.561.566-1.402.566-1.963 0a1.377 1.377 0 010-1.982 8.577 8.577 0 0112.199 0 1.377 1.377 0 010 1.982c-.421.283-.701.424-1.122.424z"
                  />
                </svg>
              </i>
              <label htmlFor="no" className="radio-text">
                {firmType.radioConfig[1].labelConfig.label}
              </label>
              <span className="select-radio" />
            </div>

            <div className="radio-field image-type">
              <input
                type="radio"
                className="radio-element"
                checked={firmType.radioConfig[2].elementConfig.checked}
                name="firmType"
                value={firmType.radioConfig[2].elementConfig.value}
                disabled={isSecondApplication}
                onChange={event =>
                  radioChangeHandler(event, "firmType", 2, formType)
                }
              />
              <i className="radio-icon">
                <svg width="49" height="47" viewBox="0 0 97 94">
                  <path
                    fill="#354060"
                    fillRule="evenodd"
                    d="M95.383 83.033h-3.38c.094.517.143 1.041.146 1.567v7.835c0 .864-.724 1.565-1.616 1.564H6.465c-.892 0-1.615-.701-1.614-1.566V84.6c.003-.526.052-1.05.146-1.567H1.615C.723 83.032 0 82.331.001 81.466V25.065c0-.865.724-1.565 1.616-1.565h24.25V1.565C25.868.701 26.591 0 27.484.001h42.034c.893 0 1.616.701 1.615 1.566V23.5h24.252c.892.001 1.615.702 1.614 1.567v56.401c0 .865-.724 1.565-1.616 1.565zm-19.4 7.833h12.933V84.6c0-3.461-2.895-6.267-6.466-6.267-3.572 0-6.467 2.806-6.467 6.267v6.266zm9.7-18.8c0-1.73-1.448-3.133-3.233-3.133-1.786 0-3.234 1.403-3.234 3.133.003 1.73 1.449 3.131 3.234 3.134 1.785 0 3.233-1.403 3.233-3.134zm-45.266 18.8h16.166V79.9c0-4.327-3.619-7.834-8.083-7.834s-8.083 3.507-8.083 7.834v10.966zM53.35 64.233c0-2.596-2.171-4.7-4.85-4.7s-4.85 2.104-4.85 4.7c.003 2.595 2.173 4.697 4.85 4.7 2.679 0 4.85-2.104 4.85-4.7zM8.084 90.866h12.933V84.6c0-3.461-2.895-6.267-6.467-6.267-3.571 0-6.466 2.806-6.466 6.267v6.266zm9.7-18.8c0-1.73-1.448-3.133-3.234-3.133-1.785 0-3.233 1.403-3.233 3.133.002 1.73 1.449 3.131 3.233 3.134 1.786 0 3.234-1.403 3.234-3.134zm8.083-8.801V26.634H3.234v53.265h2.929a9.627 9.627 0 013.71-3.529 6.126 6.126 0 010-8.654c2.466-2.503 6.559-2.596 9.142-.206a6.13 6.13 0 01.213 8.86 9.705 9.705 0 012.034 1.459c.614-2.619 2.352-4.859 4.777-6.159a6.042 6.042 0 01-.172-8.405zM24.25 79.9v10.966h12.933V79.9c0-3.461-2.895-6.267-6.466-6.267S24.25 76.439 24.25 79.9zm3.234-12.534c0 1.731 1.447 3.134 3.233 3.134s3.233-1.403 3.233-3.134c0-1.73-1.447-3.133-3.233-3.133-1.785.002-3.231 1.404-3.233 3.133zM67.9 3.134H29.1v58.188c2.202-.587 4.559.003 6.191 1.55a6.087 6.087 0 01.104 8.798 9.663 9.663 0 013.259 2.843 11.235 11.235 0 014.639-4.339 8 8 0 01-.976-.945c-2.875-3.309-2.439-8.251.976-11.038 3.414-2.787 8.514-2.364 11.39.945 2.875 3.309 2.439 8.251-.976 11.038a11.235 11.235 0 014.639 4.339 9.663 9.663 0 013.259-2.843 6.144 6.144 0 01-1.788-4.337c.009-3.452 2.904-6.242 6.466-6.233a6.58 6.58 0 011.617.222V3.134zm-1.617 61.099c-1.786 0-3.233 1.403-3.233 3.133 0 1.731 1.447 3.134 3.233 3.134s3.233-1.403 3.233-3.134c-.002-1.729-1.448-3.131-3.233-3.133zm0 9.4c-3.571 0-6.466 2.806-6.466 6.267v10.966H72.75V79.9c0-3.461-2.896-6.267-6.467-6.267zm27.483-46.999H71.133v36.631a6.042 6.042 0 01-.172 8.405c2.425 1.3 4.163 3.54 4.777 6.158a9.737 9.737 0 012.034-1.458 6.128 6.128 0 010-8.654c2.466-2.503 6.559-2.596 9.143-.206a6.131 6.131 0 01.212 8.86 9.63 9.63 0 013.71 3.53h2.929V26.634zm-8.083 9.399h3.233V61.1h-3.233V36.033zm-9.7 0h3.233V61.1h-3.233V36.033zm-16.166 14.1h3.233v3.134h-3.233v-3.134zm0-6.266h3.233V47h-3.233v-3.133zm0-6.267h3.233v3.133h-3.233V37.6zm0-6.266h3.233v3.133h-3.233v-3.133zm-1.617-9.4H38.798c-.892-.001-1.615-.702-1.615-1.567V7.832c.001-.865.725-1.565 1.617-1.565h19.402c.892.001 1.615.702 1.615 1.567v12.535c-.001.865-.725 1.565-1.617 1.565zM56.583 9.4H40.417v9.4h16.166V9.4zm-19.4 25.067H33.95v-3.133h3.233v3.133zm0 6.266H33.95V37.6h3.233v3.133zm0 6.267H33.95v-3.133h3.233V47zm0 6.267H33.95v-3.134h3.233v3.134zM43.65 28.2h-3.233v-3.133h3.233V28.2zm0 6.267h-3.233v-3.133h3.233v3.133zm0 6.266h-3.233V37.6h3.233v3.133zm0 6.267h-3.233v-3.133h3.233V47zm0 6.267h-3.233v-3.134h3.233v3.134zM50.117 28.2h-3.234v-3.133h3.234V28.2zm0 6.267h-3.234v-3.133h3.234v3.133zm0 6.266h-3.234V37.6h3.234v3.133zm0 6.267h-3.234v-3.133h3.234V47zm0 6.267h-3.234v-3.134h3.234v3.134zM56.583 28.2H53.35v-3.133h3.233V28.2zm0 6.267H53.35v-3.133h3.233v3.133zm0 6.266H53.35V37.6h3.233v3.133zm0 6.267H53.35v-3.133h3.233V47zm0 6.267H53.35v-3.134h3.233v3.134zM17.784 36.033h3.233V61.1h-3.233V36.033zm-9.7 0h3.233V61.1H8.084V36.033z"
                  />
                </svg>
              </i>

              <label htmlFor="no" className="radio-text">
                {firmType.radioConfig[2].labelConfig.label}
              </label>
              <span className="select-radio" />
            </div>
          </div>
          <div className="radio-group mb10">
            <div className="pb10">Shop Ownership<span className='required'>*</span></div>
            <div className="radio-field image-type">
              <input
                type="radio"
                className="radio-element"
                checked={shopOwnerShip.radioConfig[0].elementConfig.checked}
                name={"shopOwnerShip"}
                value={shopOwnerShip.radioConfig[1].elementConfig.value}
                disabled={isSecondApplication}
                onChange={event =>
                  radioChangeHandler(event, "shopOwnerShip", 0, formType)
                }
              />
              <i className="radio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="52"
                  height="40"
                  viewBox="0 0 104 81"
                >
                  <path
                    fill="#354060"
                    fillRule="evenodd"
                    d="M94.246 65.319v1.615c0 .579-.453 1.047-1.014 1.047-.56 0-1.015-.468-1.015-1.047v-9.162h-2.643c-.559 0-1.014-.469-1.014-1.048 0-.578.455-1.047 1.014-1.047h7.315c.56 0 1.014.469 1.014 1.047 0 .579-.453 1.048-1.014 1.048h-2.643v7.547zm-15.279 2.662c-.56 0-1.014-.469-1.014-1.048V56.724c0-.464.296-.873.729-1.004a.998.998 0 011.138.437l4.508 7.22v-6.653c0-.578.453-1.047 1.014-1.047.56 0 1.014.469 1.014 1.047v10.209c0 .465-.296.874-.728 1.006a1.007 1.007 0 01-1.138-.437l-4.508-7.22v6.651c0 .579-.453 1.048-1.015 1.048zm-4.858-2.095c.559 0 1.013.469 1.013 1.047 0 .579-.454 1.048-1.013 1.048h-4.704c-.56 0-1.013-.469-1.013-1.048V56.724c0-.578.453-1.047 1.013-1.047h4.704c.559 0 1.013.469 1.013 1.047 0 .579-.454 1.048-1.013 1.048H70.42v3.037h3.689c.559 0 1.013.469 1.013 1.047 0 .579-.454 1.048-1.013 1.048H70.42v2.982h3.689zm-59.977.906a1.32 1.32 0 01-1.319-1.325V38.633c0-.723.599-1.305 1.319-1.305H41.18c.72 0 1.32.582 1.32 1.305v26.834c0 .743-.6 1.325-1.32 1.325H14.132zm25.729-26.835h-24.41v24.206h24.41V39.957zm60.413 41.016H61.975c-.56 0-1.015-.469-1.015-1.048 0-.579.455-1.048 1.015-1.048h38.299c.936 0 1.698-.786 1.698-1.753V48.542c0-.967-.762-1.754-1.698-1.754H54.749c-.936 0-1.698.787-1.698 1.754v28.581c0 .968.762 1.754 1.698 1.754h3.981c.559 0 1.014.469 1.014 1.048 0 .579-.455 1.047-1.014 1.047h-3.981c-2.055 0-3.725-1.726-3.725-3.848V48.542c0-2.122 1.67-3.849 3.725-3.849h26.955V33.675a11.896 11.896 0 01-3.978.663c-4.758 0-8.896-2.73-10.915-6.724-2.02 3.994-6.158 6.724-10.916 6.724s-8.896-2.73-10.915-6.724c-2.019 3.994-6.157 6.724-10.915 6.724-4.758 0-8.896-2.73-10.916-6.724-2.019 3.994-6.157 6.724-10.915 6.724-1.379 0-2.719-.221-3.958-.663v37.914h42.741v2.649H4.138c-.72 0-1.32-.582-1.32-1.325 0-.722.6-1.324 1.32-1.324h1.499V32.391C2.258 30.203-.001 26.41-.001 22.074c0-.22.06-.461.18-.662L10.635 3.067A4.145 4.145 0 0114.233.98h61.514c1.479 0 2.858.803 3.578 2.087l10.476 18.345c.1.201.16.442.16.662 0 4.336-2.24 8.129-5.638 10.317v12.302h15.951c2.055 0 3.726 1.727 3.726 3.849v28.582c0 2.122-1.671 3.849-3.726 3.849zM55.895 31.708c4.858 0 8.856-3.633 9.516-8.309H46.399c.64 4.676 4.658 8.309 9.496 8.309zm-21.83 0c4.858 0 8.856-3.633 9.516-8.309H24.569c.639 4.676 4.658 8.309 9.496 8.309zm53.177-8.309h-4.238c-.72 0-1.3-.602-1.3-1.325 0-.722.58-1.324 1.3-1.324h3.378L77.046 4.392a1.463 1.463 0 00-1.299-.763H14.233c-.54 0-1.039.281-1.319.763L3.598 20.75h3.358c.72 0 1.32.602 1.32 1.324 0 .723-.6 1.325-1.32 1.325H2.738c.64 4.676 4.658 8.309 9.496 8.309s8.856-3.633 9.516-8.309h-9.156a1.32 1.32 0 01-1.319-1.325 1.32 1.32 0 011.319-1.324h64.792c.72 0 1.319.602 1.319 1.324 0 .723-.599 1.325-1.319 1.325H68.23c.64 4.676 4.658 8.309 9.496 8.309 4.858 0 8.876-3.633 9.516-8.309zM58.119 66.934V56.725c0-.578.454-1.047 1.014-1.047h2.154c1.998 0 3.622 1.677 3.622 3.74 0 1.501-.862 2.799-2.101 3.394l1.899 3.623a1.065 1.065 0 01-.409 1.42.986.986 0 01-.483.127 1.01 1.01 0 01-.892-.55l-2.239-4.274h-.536v3.776c0 .579-.455 1.047-1.015 1.047-.56 0-1.014-.468-1.014-1.047zm2.029-5.871h1.143c.877-.002 1.59-.739 1.59-1.646 0-.907-.715-1.645-1.594-1.645h-1.139v3.291z"
                  />
                </svg>
              </i>
              <label htmlFor="no" className="radio-text">
                {shopOwnerShip.radioConfig[0].labelConfig.label}
              </label>
              <span className="select-radio" />
            </div>
            <div className="radio-field image-type">
              <input
                type="radio"
                className="radio-element"
                checked={shopOwnerShip.radioConfig[1].elementConfig.checked}
                name={"shopOwnerShip"}
                value={shopOwnerShip.radioConfig[1].elementConfig.value}
                disabled={isSecondApplication}
                onChange={event =>
                  radioChangeHandler(event, "shopOwnerShip", 1, formType)
                }
              />
              <i className="radio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="36"
                  viewBox="0 0 90 73"
                >
                  <defs>
                    <filter id="owned">
                      <feFlood
                        floodColor="#354060"
                        floodOpacity="1"
                        result="floodOut"
                      />
                      <feComposite
                        in="floodOut"
                        in2="SourceGraphic"
                        operator="atop"
                        result="compOut"
                      />
                      <feBlend in="compOut" in2="SourceGraphic" />
                    </filter>
                  </defs>
                  <path
                    fillRule="evenodd"
                    d="M84.364 31.304v39.063h1.499a1.318 1.318 0 110 2.633H4.136a1.317 1.317 0 010-2.633h1.5V31.304C2.249 29.127 0 25.332 0 21.02c0-.23.06-.455.174-.654L10.635 2.082A4.146 4.146 0 0114.227 0h61.547c1.48 0 2.857.798 3.591 2.082l10.461 18.284c.115.199.174.424.174.654 0 4.312-2.25 8.107-5.636 10.284zM60.409 70.367h14.273v-4.404H60.409v4.404zm0-7.037h14.273V39.224H60.409V63.33zM8.273 70.367h49.5v-32.46c0-.727.589-1.316 1.318-1.316H76c.728 0 1.318.589 1.318 1.316v32.46h4.409V32.581a12.195 12.195 0 01-3.966.662c-4.763 0-8.898-2.731-10.92-6.708-2.022 3.977-6.158 6.708-10.921 6.708-4.763 0-8.899-2.731-10.92-6.708-2.022 3.977-6.158 6.708-10.921 6.708-4.762 0-8.898-2.731-10.92-6.708-2.021 3.977-6.157 6.708-10.92 6.708-1.388 0-2.721-.235-3.966-.663v37.787zm57.156-48.031H46.411c.645 4.667 4.662 8.274 9.509 8.274s8.865-3.607 9.509-8.274zm-21.84 0H24.57c.645 4.667 4.663 8.274 9.509 8.274 4.847 0 8.865-3.607 9.51-8.274zm39.456-2.633h3.365L77.076 3.389a1.503 1.503 0 00-1.302-.755H14.227a1.5 1.5 0 00-1.302.755L3.59 19.703h3.363a1.317 1.317 0 110 2.633H2.727c.646 4.667 4.665 8.274 9.512 8.274s8.864-3.607 9.509-8.274h-9.156a1.318 1.318 0 110-2.633h64.817a1.317 1.317 0 110 2.633h-9.157c.645 4.667 4.662 8.274 9.509 8.274s8.867-3.607 9.512-8.274h-4.228a1.318 1.318 0 110-2.633zM14.001 36.591h27.045c.728 0 1.318.589 1.318 1.316v26.739c0 .728-.59 1.317-1.318 1.317H14.001c-.728 0-1.32-.589-1.32-1.317V37.907c0-.727.592-1.316 1.32-1.316zm1.318 26.739h24.409V39.224H15.319V63.33z"
                    filter="url(#owned)"
                  />
                </svg>
              </i>
              <label htmlFor="yes" className="radio-text">
                {shopOwnerShip.radioConfig[1].labelConfig.label}
              </label>
              <span className="select-radio" />
            </div>
          </div>
          {renderedForm}
          </fieldset>
        </form>
      </div>
    );
  }
}

export default EvaluationForm;
